import { PhoneCall, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/config/siteConfig";
import { waLink, trackEvent } from "@/lib/whatsapp";
import { Reveal } from "@/components/Reveal";

export const Services = () => (
  <section id="services" className="border-t border-black/5 bg-gray-50 py-24 md:py-32" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-4 md:px-8">
      <Reveal className="mb-14 max-w-2xl">
        <p className="mb-3 font-display text-xs font-bold uppercase tracking-[0.3em] text-gray-400">02 — Nos services</p>
        <h2 className="font-display text-3xl font-extrabold tracking-tight text-black sm:text-4xl lg:text-5xl">
          Bien plus que du mobile
        </h2>
        <p className="mt-4 text-base text-gray-600 md:text-lg">
          Internet ultra rapide, téléphonie et télévision : regroupez vos services et simplifiez-vous la vie.
        </p>
      </Reveal>

      <div className="grid gap-6 lg:grid-cols-2">
        <Reveal className="lg:row-span-2">
          <article className="group flex h-full flex-col overflow-hidden rounded-3xl border border-gray-200 bg-white shadow-sm" data-testid="service-card-internet">
            <div className="overflow-hidden">
              <img
                src={SERVICES[0].image}
                alt={SERVICES[0].imageAlt}
                loading="lazy"
                className="aspect-[16/9] w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-7 md:p-9">
              <h3 className="font-display text-2xl font-bold text-black">{SERVICES[0].title}</h3>
              <p className="mt-3 text-base text-gray-600">{SERVICES[0].description}</p>
              <div className="mt-5 flex flex-wrap gap-2">
                {SERVICES[0].points.map((p) => (
                  <span key={p} className="rounded-full bg-jeem-yellow/25 px-3.5 py-1.5 text-xs font-bold text-black">{p}</span>
                ))}
              </div>
              <a
                href={waLink(SERVICES[0].whatsappMessage)}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent("clic_offre", { offre: "internet" })}
                data-testid="service-cta-internet"
                className="mt-auto inline-flex items-center gap-2 pt-7 font-display text-base font-bold text-black underline decoration-jeem-yellow decoration-4 underline-offset-4 transition-colors duration-300 hover:text-gray-600"
              >
                Demander plus d'infos <ArrowUpRight className="h-5 w-5" />
              </a>
            </div>
          </article>
        </Reveal>

        <Reveal delay={0.1}>
          <article className="flex h-full flex-col p-7 md:p-9 rounded-3xl border border-gray-200 bg-black text-white shadow-sm" data-testid="service-card-telephonie">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-jeem-yellow">
              <PhoneCall className="h-6 w-6 text-black" />
            </span>
            <h3 className="mt-5 font-display text-2xl font-bold">{SERVICES[1].title}</h3>
            <p className="mt-3 text-base text-gray-300">{SERVICES[1].description}</p>
            <div className="mt-5 flex flex-wrap gap-2">
              {SERVICES[1].points.map((p) => (
                <span key={p} className="rounded-full bg-white/10 px-3.5 py-1.5 text-xs font-bold text-white">{p}</span>
              ))}
            </div>
            <a
              href={waLink(SERVICES[1].whatsappMessage)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent("clic_offre", { offre: "telephonie" })}
              data-testid="service-cta-telephonie"
              className="mt-auto inline-flex items-center gap-2 pt-7 font-display text-base font-bold text-jeem-yellow transition-colors duration-300 hover:text-white"
            >
              Demander plus d'infos <ArrowUpRight className="h-5 w-5" />
            </a>
          </article>
        </Reveal>

        <Reveal delay={0.2}>
          <article className="group flex h-full flex-col overflow-hidden rounded-3xl border border-gray-200 bg-white shadow-sm sm:flex-row" data-testid="service-card-tv">
            <div className="overflow-hidden sm:w-2/5">
              <img
                src={SERVICES[2].image}
                alt={SERVICES[2].imageAlt}
                loading="lazy"
                className="h-full w-full object-cover aspect-[16/9] sm:aspect-auto transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-7">
              <h3 className="font-display text-2xl font-bold text-black">{SERVICES[2].title}</h3>
              <p className="mt-3 text-base text-gray-600">{SERVICES[2].description}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {SERVICES[2].points.map((p) => (
                  <span key={p} className="rounded-full bg-jeem-yellow/25 px-3.5 py-1.5 text-xs font-bold text-black">{p}</span>
                ))}
              </div>
              <a
                href={waLink(SERVICES[2].whatsappMessage)}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent("clic_offre", { offre: "tv" })}
                data-testid="service-cta-tv"
                className="mt-auto inline-flex items-center gap-2 pt-6 font-display text-base font-bold text-black underline decoration-jeem-yellow decoration-4 underline-offset-4 transition-colors duration-300 hover:text-gray-600"
              >
                Demander plus d'infos <ArrowUpRight className="h-5 w-5" />
              </a>
            </div>
          </article>
        </Reveal>
      </div>
    </div>
  </section>
);
